<template>
    <div>

        <!-- style="margin-top: 10px;" -->

        <nav aria-label="breadcrumb" class="breadcrumb-top">
            <ol class="breadcrumb breadcrumb-top p-0 mb-0">
                <li class="breadcrumb-item active">
                    <router-link to="/" id="breadcrumb-home">
                        <i class="fas fa-home text2-light"></i>
                    </router-link>
                </li>
                <li class="breadcrumb-item text2-white" :class="index == breadcrumb.length - 1 ? 'active' : ''"
                    v-for="(item, index) in breadcrumb" :key="index">
                    <span v-if="index != breadcrumb.length - 1">
                        <router-link class="card-link" v-if="item.path && item.path != $router.history.current.path && item.route_name"
                            :to="{ name: item.route_name, params: item.params }">
                            <span class="text2-light">
                                {{ item.name }}
                            </span>
                        </router-link>
                        <router-link class="card-link" v-else-if="item.path && item.path != $router.history.current.path"
                            :to="{ path: item.path }">
                            <span class="text2-light">
                                {{ item.name }}
                            </span>
                        </router-link>
                        <a href="#" class="card-link" @click.prevent="action(item)" v-else-if="item.method">
                            <span class="text2-light">
                                {{ item.name }}
                            </span>
                        </a>
                        <span class="text2-light" v-else>
                            {{ item.name }}
                        </span>
                    </span>
                    <span v-else>
                        {{ item.name }}
                    </span>
                </li>
            </ol>
        </nav>

    </div>
</template>

<script>
export default {
    data () { 
        return {
            lista: null,
        }
    },
    computed: { 
        breadcrumb: function () { 
            return this.$store.state.breadcrumb;
        }
    },
    methods: { 
        action (item) { 
            item.method ();
        }
    },
    mounted () { 
        this.$store.commit('setBreadcrumb', []);
    }
}
</script>

<style scoped>

.breadcrumb-top { 
    background-color: transparent !important;
}

</style>